/**
 * Builds the URL for backend fetch() calls.
 *
 * Express mounts routes under `/api` (see backend index.js).
 *
 * - If REACT_APP_BACKEND_URL is set (e.g. http://localhost:5000/api), it must
 *   include `/api` unless you use a custom gateway path.
 * - If it is missing or empty after trim, returns a relative `/api/...` URL so
 *   the CRA dev proxy (package.json "proxy") forwards to the backend.
 */
export function apiUrl(endpoint) {
  let path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const base = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '');

  if (!base) {
    if (!path.startsWith('/api')) path = `/api${path}`;
    return path;
  }

  return `${base}${path}`;
}
